import React from 'react';
import Header from '../Components/Header';
import TrustSection from '../Components/TrustSection';
import FormationsSection from '../Components/FormationSection';
import StatsSection from '../Components/StatsSection';
import CalendarSection from '../Components/CalendarSection';
import FormationList from '../Components/FormationList';
import TauxReussite from '../Components/TauxReussite';
import MapComponent from '../Components/MapComponent';
import ArticleCard from '../Components/ArticleCard';
import './Accueil.css'
import Accueil from "../Pages/image/Accueil.png"
import { Helmet } from 'react-helmet';

const AccueilView = (articles, accueil, formations, loading) => {


  return (
    <>
      <Helmet>
        <title>SCFPS</title>
        <meta name="description" content="Accueil de la page" />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <Header title={"SC FORMATION PREVENTION SECOURS"} image={Accueil}></Header>
      <FormationsSection />
      {loading ? (
        <div></div>
      ) : (
        <FormationList accueil={accueil} formations={formations} />
      )}
      {loading ? (
        <div></div>
      ) : (
        <StatsSection accueil={accueil} />
      )}
      {loading ? (
        <div></div>
      ) : (
        <TauxReussite accueil={accueil} />
      )}
      <MapComponent></MapComponent>
      {loading ? (
        <div></div>
      ) : (
        <div className="dernieres-actualites-section">
          <h2 className="section-title">Nos dernières actualités</h2>
          <div className="container">
            <div className="row g-4">
              {articles.map((actu, index) => (
                <a className="col-md-4" href={"/blog/" + actu.id}>
                  <div key={index}>
                    <div
                      className="card actualite-card"
                      style={{ backgroundImage: `url(${"https://backsc.osc-fr1.scalingo.io" + actu.images})` }}
                    >
                      <div className="card-overlay">
                        <h5 className="card-title">{actu.title}</h5>
                        <p className="card-date">{new Date(actu.date).toLocaleDateString('fr-FR', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric'
                        })}</p>
                        <p className="card-description">{actu.content}</p>
                        <a href={"/blog/" + actu.id} className="card-link">
                          En savoir plus &gt;
                        </a>
                      </div>
                    </div>
                  </div></a>
              ))}
            </div>
          </div>
        </div>
      )}

    </>
  )
}

export default AccueilView;
